import AxiosConfig from '../config/axios-config'

export default {

  obterDetalheEmenta (ementa) {
    return AxiosConfig.secureJalekoAPI().get(`ementa/${ementa}`).then(response => response.data)
  }

}
